// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ========== MODAL DIALOG - RESPONSIVE ========== */

.abono-modal-dialog {
  width: 90vw;
  max-width: 550px;
}

@media (max-width: 480px) {
  .abono-modal-dialog {
    width: 95vw;
    max-width: 100%;
    margin: 10px auto;
  }

  .modal-dialog {
    margin: 10px auto !important;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .abono-modal-dialog {
    width: 85vw;
    max-width: 600px;
  }
}

@media (min-width: 1025px) {
  .abono-modal-dialog {
    width: 80vw;
    max-width: 650px;
  }
}

/* ========== MODAL CONTENT ========== */

.abono-modal .modal-content {
  border: none;
  border-radius: 12px;
  box-shadow: var(--sn-sombra);
  overflow: hidden;
}

.abono-header {
  background: linear-gradient(135deg, var(--sn-accion) 0%, var(--sn-accion-hover) 100%);
  border: none;
  padding: 14px 18px;
}

.abono-title {
  color: var(--sn-accion-texto);
  font-weight: 700;
  font-size: 1.15rem;
  margin: 0;
  letter-spacing: 0.3px;
}

.abono-body {
  padding: 16px;
  background-color: var(--sn-fondo);
  max-height: 80vh;
  overflow-y: auto;
}

/* ========== SCROLL PERSONALIZADO ========== */

.abono-body::-webkit-scrollbar {
  width: 6px;
}

.abono-body::-webkit-scrollbar-track {
  background: var(--sn-superficie-3);
  border-radius: 3px;
}

.abono-body::-webkit-scrollbar-thumb {
  background: var(--sn-borde-fuerte);
  border-radius: 3px;
}

.abono-body::-webkit-scrollbar-thumb:hover {
  background: var(--sn-texto-3);
}

/* ========== ALERTAS ========== */

.abono-alert {
  border-radius: 6px;
  border-left: 4px solid var(--sn-peligro);
  background-color: var(--sn-peligro-suave);
  color: var(--sn-peligro-texto);
  padding: 10px;
  margin-bottom: 12px;
  font-size: 0.85rem;
}

.abono-alert-success {
  background-color: var(--sn-exito-suave);
  color: var(--sn-exito-texto);
  border-left: 4px solid var(--sn-exito);
}

/* ========== FORMULARIO DE BÚSQUEDA ========== */

.abono-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.abono-form-label {
  color: var(--sn-texto);
  font-weight: 700;
  font-size: 0.85rem;
  margin-bottom: 5px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.abono-input {
  border: 2px solid var(--sn-borde-fuerte);
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background-color: var(--sn-superficie);
  height: 40px;
}

.abono-input:focus {
  border-color: var(--sn-accion);
  box-shadow: 0 0 0 3px var(--sn-marca-suave);
  outline: none;
}

/* ========== TARJETA DE CLIENTE - PASO 1 ========== */

.abono-client-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: slideIn 0.3s ease-in;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ========== SECCIÓN 1: DATOS BÁSICOS ========== */

.abono-client-info {
  background: var(--sn-superficie);
  border-radius: 8px;
  padding: 0;
  border: 1px solid var(--sn-borde);
  box-shadow: var(--sn-sombra);
  overflow: hidden;
}

.abono-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid var(--sn-borde);
  font-size: 0.8rem;
  gap: 8px;
  background: var(--sn-superficie);
  transition: background-color 0.15s ease;
}

.abono-info-row:hover {
  background-color: var(--sn-superficie-2);
}

.abono-info-row:last-child {
  border-bottom: none;
}

.abono-info-row.total {
  background: var(--sn-alerta-suave);
  padding: 10px 12px;
  font-weight: 700;
  border-top: 2px solid var(--sn-alerta);
  border-bottom: none;
  margin-top: 2px;
}

.abono-label {
  color: var(--sn-texto-3);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.65rem;
  min-width: 100px;
  letter-spacing: 0.3px;
}

.abono-value {
  color: var(--sn-texto);
  font-weight: 600;
  text-align: right;
  flex: 1 1;
  font-size: 0.8rem;
}

.abono-total {
  color: var(--sn-peligro);
  font-weight: 800;
  font-size: 1.1rem;
  text-align: right;
}

.abono-status {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  border: 1px solid;
}

.abono-status.active {
  background-color: var(--sn-exito-suave);
  color: var(--sn-exito-texto);
  border-color: var(--sn-exito);
}

.abono-status.inactive {
  background-color: var(--sn-peligro-suave);
  color: var(--sn-peligro-texto);
  border-color: var(--sn-peligro);
}

/* ========== SECCIÓN 2: SERVICIOS ========== */

.abono-services-section {
  animation: slideIn 0.3s ease-in 0.1s backwards;
}

.abono-services-title {
  color: var(--sn-texto);
  font-weight: 700;
  font-size: 0.8rem;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.abono-services-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.abono-service-item {
  background: var(--sn-superficie);
  border-radius: 6px;
  padding: 8px;
  border-left: 3px solid var(--sn-exito);
  border: 1px solid var(--sn-borde);
  box-shadow: var(--sn-sombra);
  transition: all 0.2s ease;
}

.abono-service-item:hover {
  box-shadow: var(--sn-sombra);
  transform: translateY(-1px);
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--sn-borde);
}

.service-number {
  background: linear-gradient(135deg, var(--sn-accion) 0%, var(--sn-accion-hover) 100%);
  color: var(--sn-accion-texto);
  padding: 2px 7px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.65rem;
  box-shadow: var(--sn-sombra);
}

.service-type {
  font-weight: 700;
  font-size: 0.7rem;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 10px;
  background-color: var(--sn-superficie-3);
  letter-spacing: 0.2px;
}

.service-type.internet {
  background: var(--sn-exito-suave);
  color: var(--sn-exito-texto);
}

.service-type.television {
  background: var(--sn-info-suave);
  color: var(--sn-info-texto);
}

.service-details {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.service-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
  font-size: 0.7rem;
  padding: 2px 0;
}

.service-label {
  color: var(--sn-texto-3);
  font-weight: 600;
  text-transform: uppercase;
  min-width: 65px;
  font-size: 0.65rem;
  letter-spacing: 0.2px;
}

.service-value {
  color: var(--sn-texto);
  font-weight: 500;
  text-align: right;
  flex: 1 1;
  font-size: 0.7rem;
}

.service-status {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.15px;
}

.service-status.online {
  background-color: var(--sn-exito-suave);
  color: var(--sn-exito-texto);
  border: 1px solid var(--sn-exito);
}

.service-status.offline {
  background-color: var(--sn-peligro-suave);
  color: var(--sn-peligro-texto);
  border: 1px solid var(--sn-peligro);
}

/* ========== SECCIÓN 3: NOTA IMPORTANTE - MEJORADA ========== */

.abono-notice {
  background: var(--sn-alerta-suave);
  border-left: 4px solid var(--sn-alerta);
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 0.75rem;
  animation: slideIn 0.3s ease-in 0.2s backwards;
  box-shadow: var(--sn-sombra);
  border: 1px solid var(--sn-alerta);
  margin: 2px 0;
}

.notice-title {
  color: var(--sn-alerta-texto);
  font-weight: 700;
  margin: 0 0 8px 0;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.notice-title strong {
  color: var(--sn-texto);
  font-weight: 800;
}

/* ========== CONTENEDOR DESTACADO DEL MONTO ========== */

.notice-amount-wrapper {
  background: var(--sn-superficie);
  border: 2px solid var(--sn-alerta);
  border-radius: 4px;
  padding: 6px 0;
  margin: 6px 0;
  text-align: center;
  box-shadow: var(--sn-sombra);
}

.notice-amount {
  color: var(--sn-alerta-texto);
  font-weight: 900;
  font-size: 1.3rem;
  text-align: center;
  margin: 0;
  letter-spacing: 0.5px;
}

.notice-subtext {
  color: var(--sn-alerta-texto);
  font-size: 0.7rem;
  text-align: center;
  margin: 6px 0 0 0;
  font-style: italic;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

/* ========== BOTONES ========== */

.abono-button-group,
.abono-action-buttons {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.abono-btn-action {
  flex: 1 1;
  border: none;
  border-radius: 6px;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.abono-btn-action:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--sn-sombra);
}

.abono-btn-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.abono-btn-upload {
  flex: 1 1;
  background: linear-gradient(135deg, var(--sn-accion) 0%, var(--sn-accion-hover) 100%);
  color: var(--sn-accion-texto);
  border: none;
  border-radius: 6px;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.abono-btn-upload:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--sn-sombra);
}

.abono-btn-upload:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ========== PASO 2 - SUBIR IMAGEN ========== */

.abono-deposit-confirm {
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: slideIn 0.3s ease-in;
}

.abono-client-info-small {
  background: var(--sn-superficie);
  border-radius: 8px;
  padding: 8px;
  border-left: 3px solid var(--sn-marca);
  border: 1px solid var(--sn-borde);
  box-shadow: var(--sn-sombra);
}

.abono-info-row-small {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid var(--sn-borde);
  font-size: 0.75rem;
}

.abono-info-row-small:last-child {
  border-bottom: none;
}

.abono-info-row-small.total-small {
  padding-top: 7px;
  border-bottom: none;
  border-top: 1px solid var(--sn-borde);
  margin-top: 2px;
  font-weight: 700;
}

.abono-label-small {
  color: var(--sn-texto-3);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.65rem;
  min-width: 80px;
}

.abono-value-small {
  color: var(--sn-texto);
  font-weight: 600;
  text-align: right;
  flex: 1 1;
}

.abono-total-small {
  color: var(--sn-peligro);
  font-weight: 800;
  font-size: 0.95rem;
  text-align: right;
}

.deposit-preview-container-adaptive {
  border-radius: 8px;
  overflow: hidden;
  background: var(--sn-superficie-3);
  padding: 4px;
  box-shadow: var(--sn-sombra);
  margin: 6px 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  max-height: 50vh;
  min-height: 220px;
}

.deposit-preview-adaptive {
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 6px;
  display: block;
  max-width: 100%;
  max-height: 100%;
}

@media (max-width: 480px) {
  .deposit-preview-container-adaptive {
    max-height: 45vh;
    min-height: 200px;
    padding: 4px;
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  .deposit-preview-container-adaptive {
    max-height: 50vh;
    min-height: 250px;
  }
}

@media (min-width: 769px) {
  .deposit-preview-container-adaptive {
    max-height: 55vh;
    min-height: 300px;
  }
}

.deposit-file-info {
  background: var(--sn-superficie);
  border-radius: 8px;
  padding: 8px;
  border-left: 3px solid var(--sn-marca);
  border: 1px solid var(--sn-borde);
  font-size: 0.75rem;
  box-shadow: var(--sn-sombra);
}

.file-name {
  color: var(--sn-texto);
  font-weight: 600;
  margin: 0 0 2px 0;
  font-size: 0.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  color: var(--sn-texto-3);
  font-size: 0.7rem;
  margin: 0;
}

.deposit-progress {
  padding: 6px 0;
}

.progress-bar {
  width: 100%;
  height: 20px;
  background-color: var(--sn-superficie-3);
  border-radius: 6px;
  overflow: hidden;
  /* Rebaje del canal. En negro fijo no se veia sobre grafito: el token
     invierte la sombra a un filo de luz cuando el tema es oscuro. */
  box-shadow: var(--sn-sombra-interna);
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--sn-exito) 0%, var(--sn-exito-texto) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sn-texto-invertido);
  font-weight: 700;
  font-size: 0.65rem;
  transition: width 0.3s ease;
  min-width: 30px;
}

/* ========== PASO 3 - RESULTADO VALIDACIÓN ========== */

.abono-validation-result {
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: slideIn 0.3s ease-in;
}

.deposit-details {
  background: var(--sn-superficie);
  border-radius: 8px;
  padding: 8px;
  border-left: 3px solid var(--sn-marca);
  border: 1px solid var(--sn-borde);
  font-size: 0.75rem;
  box-shadow: var(--sn-sombra);
}

.deposit-details-title {
  color: var(--sn-texto);
  font-weight: 700;
  font-size: 0.75rem;
  margin: 0 0 6px 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.deposit-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid var(--sn-borde);
  font-size: 0.75rem;
}

.deposit-detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  color: var(--sn-texto-3);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.65rem;
  min-width: 65px;
}

.detail-value {
  color: var(--sn-texto);
  font-weight: 500;
  text-align: right;
  flex: 1 1;
  font-size: 0.75rem;
}

.deposit-amount {
  color: var(--sn-exito);
  font-weight: 700;
  font-size: 0.9rem;
}

.validation-success {
  background: var(--sn-exito-suave);
  border-left: 3px solid var(--sn-exito);
  border-radius: 6px;
  padding: 8px;
  border: 1px solid var(--sn-exito);
}

.validation-error {
  background: var(--sn-peligro-suave);
  border-left: 3px solid var(--sn-peligro);
  border-radius: 6px;
  padding: 8px;
  border: 1px solid var(--sn-peligro);
}

.validation-text {
  color: var(--sn-exito-texto);
  font-weight: 700;
  margin: 0 0 3px 0;
  font-size: 0.8rem;
}

.validation-error .validation-text {
  color: var(--sn-peligro-texto);
}

.validation-subtext {
  color: var(--sn-exito-texto);
  font-size: 0.7rem;
  margin: 0;
  font-style: italic;
}

.validation-error .validation-subtext {
  color: var(--sn-peligro-texto);
}

/* ========== RESPONSIVE ========== */

@media (max-width: 480px) {
  .abono-header {
    padding: 12px 16px;
  }

  .abono-title {
    font-size: 1rem;
  }

  .abono-body {
    padding: 14px;
    max-height: 85vh;
  }

  .abono-info-row {
    padding: 6px 10px;
    font-size: 0.75rem;
  }

  .abono-label {
    min-width: 85px;
    font-size: 0.6rem;
  }

  .abono-value {
    font-size: 0.75rem;
  }

  .abono-total {
    font-size: 1rem;
  }

  .abono-service-item {
    padding: 6px;
  }

  .service-header {
    margin-bottom: 4px;
    padding-bottom: 4px;
  }

  .notice-amount {
    font-size: 1.1rem;
  }

  .abono-button-group,
  .abono-action-buttons {
    gap: 6px;
    margin-top: 8px;
  }

  .abono-btn-action,
  .abono-btn-upload {
    padding: 8px 10px;
    font-size: 0.75rem;
    min-height: 35px;
  }

  .notice-title {
    font-size: 0.7rem;
    margin-bottom: 6px;
  }

  .notice-amount-wrapper {
    padding: 4px 0;
    margin: 4px 0;
  }

  .notice-subtext {
    font-size: 0.65rem;
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  .abono-info-row {
    padding: 7px 11px;
  }

  .abono-service-item {
    padding: 7px;
  }

  .abono-notice {
    padding: 9px 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AbonoFacturaModal.css"],"names":[],"mappings":";AACA,oDAAoD;;AAEpD;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,wCAAwC;;AAExC;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qFAAqF;EACrF,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+CAA+C;;AAE/C;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kCAAkC;;AAElC;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yCAAyC;EACzC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,aAAa;AACf;;AAEA,sDAAsD;;AAEtD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mDAAmD;;AAEnD;EACE,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;EACjB,QAAQ;EACR,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,+CAA+C;;AAE/C;EACE,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,qFAAqF;EACrF,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,gEAAgE;;AAEhE;EACE,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,4BAA4B;EAC5B,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,yDAAyD;;AAEzD;EACE,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,kCAAkC;;AAElC;;EAEE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qFAAqF;EACrF,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,SAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB;oEACkE;EAClE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kFAAkF;EAClF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qCAAqC;;AAErC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,QAAQ;IACR,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["\n/* ========== MODAL DIALOG - RESPONSIVE ========== */\n\n.abono-modal-dialog {\n  width: 90vw;\n  max-width: 550px;\n}\n\n@media (max-width: 480px) {\n  .abono-modal-dialog {\n    width: 95vw;\n    max-width: 100%;\n    margin: 10px auto;\n  }\n\n  .modal-dialog {\n    margin: 10px auto !important;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 1024px) {\n  .abono-modal-dialog {\n    width: 85vw;\n    max-width: 600px;\n  }\n}\n\n@media (min-width: 1025px) {\n  .abono-modal-dialog {\n    width: 80vw;\n    max-width: 650px;\n  }\n}\n\n/* ========== MODAL CONTENT ========== */\n\n.abono-modal .modal-content {\n  border: none;\n  border-radius: 12px;\n  box-shadow: var(--sn-sombra);\n  overflow: hidden;\n}\n\n.abono-header {\n  background: linear-gradient(135deg, var(--sn-accion) 0%, var(--sn-accion-hover) 100%);\n  border: none;\n  padding: 14px 18px;\n}\n\n.abono-title {\n  color: var(--sn-accion-texto);\n  font-weight: 700;\n  font-size: 1.15rem;\n  margin: 0;\n  letter-spacing: 0.3px;\n}\n\n.abono-body {\n  padding: 16px;\n  background-color: var(--sn-fondo);\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n/* ========== SCROLL PERSONALIZADO ========== */\n\n.abono-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.abono-body::-webkit-scrollbar-track {\n  background: var(--sn-superficie-3);\n  border-radius: 3px;\n}\n\n.abono-body::-webkit-scrollbar-thumb {\n  background: var(--sn-borde-fuerte);\n  border-radius: 3px;\n}\n\n.abono-body::-webkit-scrollbar-thumb:hover {\n  background: var(--sn-texto-3);\n}\n\n/* ========== ALERTAS ========== */\n\n.abono-alert {\n  border-radius: 6px;\n  border-left: 4px solid var(--sn-peligro);\n  background-color: var(--sn-peligro-suave);\n  color: var(--sn-peligro-texto);\n  padding: 10px;\n  margin-bottom: 12px;\n  font-size: 0.85rem;\n}\n\n.abono-alert-success {\n  background-color: var(--sn-exito-suave);\n  color: var(--sn-exito-texto);\n  border-left: 4px solid var(--sn-exito);\n}\n\n/* ========== FORMULARIO DE BÚSQUEDA ========== */\n\n.abono-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.abono-form-label {\n  color: var(--sn-texto);\n  font-weight: 700;\n  font-size: 0.85rem;\n  margin-bottom: 5px;\n  display: block;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.abono-input {\n  border: 2px solid var(--sn-borde-fuerte);\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  background-color: var(--sn-superficie);\n  height: 40px;\n}\n\n.abono-input:focus {\n  border-color: var(--sn-accion);\n  box-shadow: 0 0 0 3px var(--sn-marca-suave);\n  outline: none;\n}\n\n/* ========== TARJETA DE CLIENTE - PASO 1 ========== */\n\n.abono-client-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  animation: slideIn 0.3s ease-in;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ========== SECCIÓN 1: DATOS BÁSICOS ========== */\n\n.abono-client-info {\n  background: var(--sn-superficie);\n  border-radius: 8px;\n  padding: 0;\n  border: 1px solid var(--sn-borde);\n  box-shadow: var(--sn-sombra);\n  overflow: hidden;\n}\n\n.abono-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--sn-borde);\n  font-size: 0.8rem;\n  gap: 8px;\n  background: var(--sn-superficie);\n  transition: background-color 0.15s ease;\n}\n\n.abono-info-row:hover {\n  background-color: var(--sn-superficie-2);\n}\n\n.abono-info-row:last-child {\n  border-bottom: none;\n}\n\n.abono-info-row.total {\n  background: var(--sn-alerta-suave);\n  padding: 10px 12px;\n  font-weight: 700;\n  border-top: 2px solid var(--sn-alerta);\n  border-bottom: none;\n  margin-top: 2px;\n}\n\n.abono-label {\n  color: var(--sn-texto-3);\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 0.65rem;\n  min-width: 100px;\n  letter-spacing: 0.3px;\n}\n\n.abono-value {\n  color: var(--sn-texto);\n  font-weight: 600;\n  text-align: right;\n  flex: 1;\n  font-size: 0.8rem;\n}\n\n.abono-total {\n  color: var(--sn-peligro);\n  font-weight: 800;\n  font-size: 1.1rem;\n  text-align: right;\n}\n\n.abono-status {\n  display: inline-block;\n  padding: 3px 9px;\n  border-radius: 12px;\n  font-weight: 700;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n  border: 1px solid;\n}\n\n.abono-status.active {\n  background-color: var(--sn-exito-suave);\n  color: var(--sn-exito-texto);\n  border-color: var(--sn-exito);\n}\n\n.abono-status.inactive {\n  background-color: var(--sn-peligro-suave);\n  color: var(--sn-peligro-texto);\n  border-color: var(--sn-peligro);\n}\n\n/* ========== SECCIÓN 2: SERVICIOS ========== */\n\n.abono-services-section {\n  animation: slideIn 0.3s ease-in 0.1s backwards;\n}\n\n.abono-services-title {\n  color: var(--sn-texto);\n  font-weight: 700;\n  font-size: 0.8rem;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.abono-services-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.abono-service-item {\n  background: var(--sn-superficie);\n  border-radius: 6px;\n  padding: 8px;\n  border-left: 3px solid var(--sn-exito);\n  border: 1px solid var(--sn-borde);\n  box-shadow: var(--sn-sombra);\n  transition: all 0.2s ease;\n}\n\n.abono-service-item:hover {\n  box-shadow: var(--sn-sombra);\n  transform: translateY(-1px);\n}\n\n.service-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid var(--sn-borde);\n}\n\n.service-number {\n  background: linear-gradient(135deg, var(--sn-accion) 0%, var(--sn-accion-hover) 100%);\n  color: var(--sn-accion-texto);\n  padding: 2px 7px;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 0.65rem;\n  box-shadow: var(--sn-sombra);\n}\n\n.service-type {\n  font-weight: 700;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 10px;\n  background-color: var(--sn-superficie-3);\n  letter-spacing: 0.2px;\n}\n\n.service-type.internet {\n  background: var(--sn-exito-suave);\n  color: var(--sn-exito-texto);\n}\n\n.service-type.television {\n  background: var(--sn-info-suave);\n  color: var(--sn-info-texto);\n}\n\n.service-details {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.service-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 0.7rem;\n  padding: 2px 0;\n}\n\n.service-label {\n  color: var(--sn-texto-3);\n  font-weight: 600;\n  text-transform: uppercase;\n  min-width: 65px;\n  font-size: 0.65rem;\n  letter-spacing: 0.2px;\n}\n\n.service-value {\n  color: var(--sn-texto);\n  font-weight: 500;\n  text-align: right;\n  flex: 1;\n  font-size: 0.7rem;\n}\n\n.service-status {\n  display: inline-block;\n  padding: 2px 7px;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.15px;\n}\n\n.service-status.online {\n  background-color: var(--sn-exito-suave);\n  color: var(--sn-exito-texto);\n  border: 1px solid var(--sn-exito);\n}\n\n.service-status.offline {\n  background-color: var(--sn-peligro-suave);\n  color: var(--sn-peligro-texto);\n  border: 1px solid var(--sn-peligro);\n}\n\n/* ========== SECCIÓN 3: NOTA IMPORTANTE - MEJORADA ========== */\n\n.abono-notice {\n  background: var(--sn-alerta-suave);\n  border-left: 4px solid var(--sn-alerta);\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 0.75rem;\n  animation: slideIn 0.3s ease-in 0.2s backwards;\n  box-shadow: var(--sn-sombra);\n  border: 1px solid var(--sn-alerta);\n  margin: 2px 0;\n}\n\n.notice-title {\n  color: var(--sn-alerta-texto);\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  font-size: 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.notice-title strong {\n  color: var(--sn-texto);\n  font-weight: 800;\n}\n\n/* ========== CONTENEDOR DESTACADO DEL MONTO ========== */\n\n.notice-amount-wrapper {\n  background: var(--sn-superficie);\n  border: 2px solid var(--sn-alerta);\n  border-radius: 4px;\n  padding: 6px 0;\n  margin: 6px 0;\n  text-align: center;\n  box-shadow: var(--sn-sombra);\n}\n\n.notice-amount {\n  color: var(--sn-alerta-texto);\n  font-weight: 900;\n  font-size: 1.3rem;\n  text-align: center;\n  margin: 0;\n  letter-spacing: 0.5px;\n}\n\n.notice-subtext {\n  color: var(--sn-alerta-texto);\n  font-size: 0.7rem;\n  text-align: center;\n  margin: 6px 0 0 0;\n  font-style: italic;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n/* ========== BOTONES ========== */\n\n.abono-button-group,\n.abono-action-buttons {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.abono-btn-action {\n  flex: 1;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-weight: 700;\n  font-size: 0.8rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  min-height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.abono-btn-action:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--sn-sombra);\n}\n\n.abono-btn-action:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.abono-btn-upload {\n  flex: 1;\n  background: linear-gradient(135deg, var(--sn-accion) 0%, var(--sn-accion-hover) 100%);\n  color: var(--sn-accion-texto);\n  border: none;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-weight: 700;\n  font-size: 0.8rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  min-height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.abono-btn-upload:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--sn-sombra);\n}\n\n.abono-btn-upload:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ========== PASO 2 - SUBIR IMAGEN ========== */\n\n.abono-deposit-confirm {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  animation: slideIn 0.3s ease-in;\n}\n\n.abono-client-info-small {\n  background: var(--sn-superficie);\n  border-radius: 8px;\n  padding: 8px;\n  border-left: 3px solid var(--sn-marca);\n  border: 1px solid var(--sn-borde);\n  box-shadow: var(--sn-sombra);\n}\n\n.abono-info-row-small {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 0;\n  border-bottom: 1px solid var(--sn-borde);\n  font-size: 0.75rem;\n}\n\n.abono-info-row-small:last-child {\n  border-bottom: none;\n}\n\n.abono-info-row-small.total-small {\n  padding-top: 7px;\n  border-bottom: none;\n  border-top: 1px solid var(--sn-borde);\n  margin-top: 2px;\n  font-weight: 700;\n}\n\n.abono-label-small {\n  color: var(--sn-texto-3);\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 0.65rem;\n  min-width: 80px;\n}\n\n.abono-value-small {\n  color: var(--sn-texto);\n  font-weight: 600;\n  text-align: right;\n  flex: 1;\n}\n\n.abono-total-small {\n  color: var(--sn-peligro);\n  font-weight: 800;\n  font-size: 0.95rem;\n  text-align: right;\n}\n\n.deposit-preview-container-adaptive {\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--sn-superficie-3);\n  padding: 4px;\n  box-shadow: var(--sn-sombra);\n  margin: 6px 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-auto-rows: auto;\n  max-height: 50vh;\n  min-height: 220px;\n}\n\n.deposit-preview-adaptive {\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  border-radius: 6px;\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n@media (max-width: 480px) {\n  .deposit-preview-container-adaptive {\n    max-height: 45vh;\n    min-height: 200px;\n    padding: 4px;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 768px) {\n  .deposit-preview-container-adaptive {\n    max-height: 50vh;\n    min-height: 250px;\n  }\n}\n\n@media (min-width: 769px) {\n  .deposit-preview-container-adaptive {\n    max-height: 55vh;\n    min-height: 300px;\n  }\n}\n\n.deposit-file-info {\n  background: var(--sn-superficie);\n  border-radius: 8px;\n  padding: 8px;\n  border-left: 3px solid var(--sn-marca);\n  border: 1px solid var(--sn-borde);\n  font-size: 0.75rem;\n  box-shadow: var(--sn-sombra);\n}\n\n.file-name {\n  color: var(--sn-texto);\n  font-weight: 600;\n  margin: 0 0 2px 0;\n  font-size: 0.7rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-size {\n  color: var(--sn-texto-3);\n  font-size: 0.7rem;\n  margin: 0;\n}\n\n.deposit-progress {\n  padding: 6px 0;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 20px;\n  background-color: var(--sn-superficie-3);\n  border-radius: 6px;\n  overflow: hidden;\n  /* Rebaje del canal. En negro fijo no se veia sobre grafito: el token\n     invierte la sombra a un filo de luz cuando el tema es oscuro. */\n  box-shadow: var(--sn-sombra-interna);\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--sn-exito) 0%, var(--sn-exito-texto) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--sn-texto-invertido);\n  font-weight: 700;\n  font-size: 0.65rem;\n  transition: width 0.3s ease;\n  min-width: 30px;\n}\n\n/* ========== PASO 3 - RESULTADO VALIDACIÓN ========== */\n\n.abono-validation-result {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  animation: slideIn 0.3s ease-in;\n}\n\n.deposit-details {\n  background: var(--sn-superficie);\n  border-radius: 8px;\n  padding: 8px;\n  border-left: 3px solid var(--sn-marca);\n  border: 1px solid var(--sn-borde);\n  font-size: 0.75rem;\n  box-shadow: var(--sn-sombra);\n}\n\n.deposit-details-title {\n  color: var(--sn-texto);\n  font-weight: 700;\n  font-size: 0.75rem;\n  margin: 0 0 6px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.deposit-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 0;\n  border-bottom: 1px solid var(--sn-borde);\n  font-size: 0.75rem;\n}\n\n.deposit-detail-row:last-child {\n  border-bottom: none;\n}\n\n.detail-label {\n  color: var(--sn-texto-3);\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.65rem;\n  min-width: 65px;\n}\n\n.detail-value {\n  color: var(--sn-texto);\n  font-weight: 500;\n  text-align: right;\n  flex: 1;\n  font-size: 0.75rem;\n}\n\n.deposit-amount {\n  color: var(--sn-exito);\n  font-weight: 700;\n  font-size: 0.9rem;\n}\n\n.validation-success {\n  background: var(--sn-exito-suave);\n  border-left: 3px solid var(--sn-exito);\n  border-radius: 6px;\n  padding: 8px;\n  border: 1px solid var(--sn-exito);\n}\n\n.validation-error {\n  background: var(--sn-peligro-suave);\n  border-left: 3px solid var(--sn-peligro);\n  border-radius: 6px;\n  padding: 8px;\n  border: 1px solid var(--sn-peligro);\n}\n\n.validation-text {\n  color: var(--sn-exito-texto);\n  font-weight: 700;\n  margin: 0 0 3px 0;\n  font-size: 0.8rem;\n}\n\n.validation-error .validation-text {\n  color: var(--sn-peligro-texto);\n}\n\n.validation-subtext {\n  color: var(--sn-exito-texto);\n  font-size: 0.7rem;\n  margin: 0;\n  font-style: italic;\n}\n\n.validation-error .validation-subtext {\n  color: var(--sn-peligro-texto);\n}\n\n/* ========== RESPONSIVE ========== */\n\n@media (max-width: 480px) {\n  .abono-header {\n    padding: 12px 16px;\n  }\n\n  .abono-title {\n    font-size: 1rem;\n  }\n\n  .abono-body {\n    padding: 14px;\n    max-height: 85vh;\n  }\n\n  .abono-info-row {\n    padding: 6px 10px;\n    font-size: 0.75rem;\n  }\n\n  .abono-label {\n    min-width: 85px;\n    font-size: 0.6rem;\n  }\n\n  .abono-value {\n    font-size: 0.75rem;\n  }\n\n  .abono-total {\n    font-size: 1rem;\n  }\n\n  .abono-service-item {\n    padding: 6px;\n  }\n\n  .service-header {\n    margin-bottom: 4px;\n    padding-bottom: 4px;\n  }\n\n  .notice-amount {\n    font-size: 1.1rem;\n  }\n\n  .abono-button-group,\n  .abono-action-buttons {\n    gap: 6px;\n    margin-top: 8px;\n  }\n\n  .abono-btn-action,\n  .abono-btn-upload {\n    padding: 8px 10px;\n    font-size: 0.75rem;\n    min-height: 35px;\n  }\n\n  .notice-title {\n    font-size: 0.7rem;\n    margin-bottom: 6px;\n  }\n\n  .notice-amount-wrapper {\n    padding: 4px 0;\n    margin: 4px 0;\n  }\n\n  .notice-subtext {\n    font-size: 0.65rem;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 768px) {\n  .abono-info-row {\n    padding: 7px 11px;\n  }\n\n  .abono-service-item {\n    padding: 7px;\n  }\n\n  .abono-notice {\n    padding: 9px 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
